export default "__VITE_ASSET__CvuyBZnu__"